export default __webpack_public_path__ + "static/media/SET_OK.2803d37e.svg";